import {
  OrderLockedMessage,
  OrderLockedPaymentMethod,
  useLockedOrderCtx,
} from '~shared/segments/OrderLockedScreen'

import { CreateNewOrderButton } from '../../contexts/ValidateOrderStatus/CreateNewOrderButton'
import { LockedScreenResponsiveLayout } from '../../segments/LockedScreen'
import { GoToPaymentButton } from './components/GoToPaymentButton'

type TProps = NoChildren

/**
 * Presents a UI with options to change the method & return to the payment gate.
 * Logic is handled by components & context from `LockedOrderProvider` & `LockedOrderPaymentMethodProvider`.
 */
export const OrderLockedScreenResponsiveContent: React.FC<TProps> = () => {
  const order = useLockedOrderCtx()

  const buttons = (
    <>
      <GoToPaymentButton />
      <CreateNewOrderButton />
    </>
  )

  return (
    <LockedScreenResponsiveLayout
      title={`OrderLocked`}
      description={<OrderLockedMessage />}
      order={order}
      buttons={buttons}
    >
      <OrderLockedPaymentMethod />
    </LockedScreenResponsiveLayout>
  )
}
